import axios from '@/services/axios.js'
import vue from 'vue'
import { getHeadersWithAccessToken } from '../../functions'

const state = {
    allStores: [],
    stores: [],
    storeInterests: [],
    alertInterests: [],
    users: [],
    userMessages: [],
    settingsMenuMode: 'horizontal',
    devMode: (localStorage.getItem('devMode') === 'true'),
    orgName: 'No organistaion',
    windowWidth: ''
}

const mutations = {
    'SET_STORES' (state, payload) {
        vue.set(state, 'stores', payload)
    },
    'SET_ALL_STORES' (state, payload) {
        vue.set(state, 'allStores', payload)
    },
    'SET_USERS' (state, payload) {
        vue.set(state, 'users', payload)
    },
    'SET_STORE_INTERESTS' (state, payload) {
        vue.set(state, 'storeInterests', payload)
    },
    'SET_ALERT_INTERESTS' (state, payload) {
        vue.set(state, 'alertInterests', payload)
    },
    'SET_MESSAGES' (state, payload) {
        vue.set(state, 'messages', payload)
    },
    'SET_USER_MESSAGES' (state, payload) {
        vue.set(state, 'userMessages', payload)
    },
    'SET_ORG' (state, payload) {
        vue.set(state, 'orgName', payload)
    },
    'SET_WINDOW_WIDTH' (state, payload) {
        vue.set(state, 'windowWidth', payload)
    }
}

const actions = {
    getStores: ({ commit }) => {
        return axios.post(((state.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/general/general/store_select', { format: 'aod' }, { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_STORES', response.data.data)
            })
            .catch(error => {
                console.log(error)
            })
    },
    getAllStores: ({ commit }) => {
        return axios.get(((state.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/stores', { format: 'aod', 'headers': getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_ALL_STORES', response.data.data)
            })
            .catch(error => {
                console.log(error)
            })
    },
    getStoreInterests: ({ commit }) => {
        return axios.get(((state.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/all_interests_stores', { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_STORE_INTERESTS', response.data.data)
            })
            .catch(error => {
                console.log(error)
            })
    },
    getAlertInterests: ({ commit }, payload) => {
        return axios.get(((state.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/user_interests?user_id=' + payload, { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_ALERT_INTERESTS', response.data.data)
            })
            .catch(error => {
                console.log(error)
            })
    },
    getUsers: ({ commit }) => {
        return axios.get(((state.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/users', { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_USERS', response.data.data)
            })
            .catch(error => {
                console.log(error)
            })
    },
    getOrganisation: ({ commit }) => {
        return axios.post(((state.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/general/general/org_details', { 'format': 'd' }, { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_ORG', response.data.data['org_name'])
            }).catch(error => {
                console.log(error)
            })
    },
    getUserMessages: ({ commit }, payload) => {
        return axios.get(((state.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/user_message?user_id=' + payload, { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_USER_MESSAGES', response.data.data)
            })
            .catch(error => {
                console.log(error)
            })
    }
}

const getters = {
    getStores: state => { return JSON.parse(JSON.stringify(state.stores)) },
    getAllStores: state => { return JSON.parse(JSON.stringify(state.allStores)) },
    getUsers: state => { return JSON.parse(JSON.stringify(state.users)) },
    getStoreInterests: state => { return JSON.parse(JSON.stringify(state.storeInterests)) },
    getAlertInterests: state => { return JSON.parse(JSON.stringify(state.alertInterests)) },
    getUserMessages: state => { return JSON.parse(JSON.stringify(state.userMessages)) },
    storesLoaded: state => { return state.stores.length > 0 },
    allStoresLoaded: state => { return state.allStores.length > 0 },
    interestsLoaded: state => { return state.storeInterests.length > 0 }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
